import React, {CSSProperties, useEffect, useState} from 'react';
import {Image} from "react-bootstrap";
import {handicaddieSelector} from "../services/store/asyncThunk";
import {UserService} from "../services/api/UserService";

interface Props {
    url?: string
    user?: string | 'current'
    size: 'xs' | 's' | 'smd' | 'md' | 'lg'
    style?: CSSProperties
    round?: boolean
}

const PLACEHOLDER_AVATAR = '/placeholder.png'

const Avatar = ({url, user, size, style, round=true}: Props) => {

    const { userAvatar } = handicaddieSelector(state => state.session)

    const { getAvatar } = UserService();

    const [avatar, setAvatar] = useState<string>(PLACEHOLDER_AVATAR)

    useEffect(() => {
        if (url) {
            setAvatar(url)
            return
        }

        if (user === 'current') {
            if (userAvatar) {
                setAvatar(userAvatar)
            }
        } else {
            if (user) {
                loadUserAvatar(user)
            } else {
                setAvatar(PLACEHOLDER_AVATAR)
            }
        }
    }, [url, user, userAvatar])

    const loadUserAvatar = async (userId: string) => {
        setAvatar(PLACEHOLDER_AVATAR)
        let a = await getAvatar(userId)
        if (a.avatar) {
            setAvatar(a.avatar)
        }
    }

    let s = '1em'

    switch (size) {
        case "xs":
            s = '2em'
            break
        case "s":
            s = '5em'
            break
        case "smd":
            s = '7em'
            break
        case "md":
            s = '10em'
            break
        case "lg":
            s = '15em'
            break
    }

    let finalStyle = {
        width: s,
        height: s,
        ...style
    }

    return (
        <Image
            className="announcementBanner_avatar"
            src={avatar}
            style={finalStyle}
            draggable={false}
            roundedCircle={round}
        />
    )
}

export default Avatar;

